import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { IMAGES } from "@/data/content";
import { Reveal } from "./anim";

export default function Manifesto() {
  const { t } = useLang();
  const m = t.manifesto;

  return (
    <section id="experience" className="relative py-24 md:py-36 bg-ink text-cream overflow-hidden" data-testid="manifesto-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-[1fr_1fr] gap-14 lg:gap-24">
          {/* Left sticky heading + image */}
          <div className="lg:sticky lg:top-28 self-start">
            <Reveal>
              <p className="text-xs tracking-[0.25em] uppercase text-brand mb-6">{m.overline}</p>
              <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-[3.75rem] leading-[1.08] tracking-tight">
                {m.title}
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="clip-frame mt-12">
                <img src={IMAGES.therapist} alt="" className="w-full h-[420px] object-cover object-top" />
              </div>
            </Reveal>
          </div>

          {/* Right chapters */}
          <div className="flex flex-col">
            {m.chapters.map((c, i) => (
              <motion.div
                key={c.n}
                initial={{ opacity: 0, y: 34 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.75, ease: [0.76, 0, 0.24, 1] }}
                className="border-b border-cream/15 py-9"
                data-testid={`chapter-${c.n}`}
              >
                <div className="flex items-baseline gap-6">
                  <span className="font-serif italic text-brand/80 text-3xl md:text-4xl">{c.n}</span>
                  <div>
                    <h3 className="font-serif text-2xl md:text-3xl">{c.title}</h3>
                    <p className="mt-3 font-light text-sm md:text-base leading-relaxed text-cream/60 max-w-lg">
                      {c.text}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
